import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-next",
  "use": "icon-play-next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play-next\">\n<path d=\"M17.5 11.134C18.1667 11.5189 18.1667 12.4811 17.5 12.866L10 17.1962C9.33333 17.5811 8.5 17.0999 8.5 16.3301L8.5 7.66987C8.5 6.90007 9.33333 6.41895 10 6.80385L17.5 11.134Z\" stroke=\"currentColor\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol